import { AssessmentResultItem } from "../../model/AssessmentResultItem";
import ServiceEndpoints from "../ServiceEndpoints";
import {AssessmentStatusResult} from "../../model/AssessmentStatusResult";
 
export async function fetchViewAssessmentResults(poiEncryptedId: string, assessmentForm: any, token: any): Promise<AssessmentResultItem> {
    const assessmentOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
      body: JSON.stringify(assessmentForm),
    };
 
    try {
      const response = await fetch(ServiceEndpoints.Assessment + poiEncryptedId, assessmentOptions);
  
      if (response.status === 200) {
        const data = await response.json();
        return data as AssessmentResultItem;
      } else {
        throw new Error("Request failed with status: " + response.status);
      }
    } catch (error) {
      console.error("API error " + error);
      return  {
        results: [{
          personId: 0,
          assessingCompetentAuthority: "",
          caCode: "",
          caInternalAssessmentNo: "",
          euSectoralLegislativeBasis: "",
          dateOfAssessment: "",
          assessmentId: 0,
          encryptedId: ""
        }],
        totalItems: 0,
        totalPages: 0
      }
    }
  }

  export async function fetchCreateAssessmentResults(userId: string, assessmentForm: any, token: any): Promise<AssessmentResultItem> {
    const assessmentOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
      body: JSON.stringify(assessmentForm),
    };
 
    try {
      const response = await fetch(ServiceEndpoints.FilteredAssement + userId, assessmentOptions);
  
      if (response.status === 200) {
        const data = await response.json();
        return data as AssessmentResultItem;
      } else {
        throw new Error("Request failed with status: " + response.status);
      }
    } catch (error) {
      console.error("API error " + error);
      return  {
        results: [{
          personId: 0,
          assessingCompetentAuthority: "",
          caCode: "",
          caInternalAssessmentNo: "",
          euSectoralLegislativeBasis: "",
          dateOfAssessment: "",
          assessmentId: 0,
          encryptedId: ""
        }],
        totalItems: 0,
        totalPages: 0
      }
    }
  }

  export async function fetchAssessmentStatus(poiEncryptedId: string, token: any): Promise<AssessmentStatusResult> {
    const assessmentOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
    };

    try {
      const response = await fetch(ServiceEndpoints.StatusAssessment + poiEncryptedId, assessmentOptions)

      if (response.status === 200) {
        const data = await response.json();
        return data as AssessmentStatusResult;
      } else {
        throw new Error("Request failed with status: " + response.status);
      }
    } catch (error) {
      console.error("API error " + error)
      return {
        hasAssessmentsForNca: false,
        hasAssessmentsOnlyForNca: false
      }
    }
  }